import React from 'react';

const CalendarSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 4V2h-1v2H8V2H7v2H2v18h20V4h-5zm4 17H3V9h18v12zM3 8V5h4v1h1V5h8v1h1V5h4v3H3z"
        />
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M15 16h2v2h-2zM11 16h2v2h-2zM7 16h2v2H7zM15 12h2v2h-2zM11 12h2v2h-2zM7 12h2v2H7z" />
        </g>
    </svg>
);

CalendarSvg.displayName = 'CalendarSvg';
export default CalendarSvg;
